module.exports = __webpack_public_path__ + "static/media/death-certificate.08b9baf8.aif";